import type { FC } from 'react'

/**
 * The worksbq mark: a w built from three bars, with one block of quantity
 * resting on the middle one. Drawn in a 32-unit box so it stays crisp from the
 * 20px favicon up. `reversed` is for dark grounds; never recolour the bars.
 */
export interface LogoMarkProps {
  size?: number
  reversed?: boolean
}

export const LogoMark: FC<LogoMarkProps> = ({ size = 32, reversed = false }) => {
  const tile = reversed ? '#ffffff' : '#111114'
  const bar = reversed ? '#111114' : '#ffffff'
  const block = reversed ? '#7c5cfa' : '#8b6cff'
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block', flex: 'none' }}
    >
      <rect width="32" height="32" rx="9" fill={tile} />
      <rect x="7" y="11" width="4.5" height="13" rx="2.25" fill={bar} />
      <rect x="13.75" y="15" width="4.5" height="9" rx="2.25" fill={bar} />
      <rect x="20.5" y="11" width="4.5" height="13" rx="2.25" fill={bar} />
      <rect x="13.75" y="7" width="4.5" height="4.5" rx="1.2" fill={block} />
    </svg>
  )
}

export interface WordmarkProps {
  /** Height of the mark in px; the word scales with it. */
  size?: number
  reversed?: boolean
}

/** Mark plus the name. Always lower case, one word, "bq" in the accent. */
export const Wordmark: FC<WordmarkProps> = ({ size = 32, reversed = false }) => (
  <span className={reversed ? 'wordmark wordmark--reversed' : 'wordmark'} style={{ fontSize: Math.round(size * 0.7) }}>
    <LogoMark size={size} reversed={reversed} />
    <span className="wordmark__word">works<span className="wordmark__bq">bq</span></span>
  </span>
)
